<script setup lang="ts">
import { Box } from '@collector/shared-ui'

import PocketIncidentsButtons from './PocketIncidentsButtons.vue'
</script>

<template>
  <Box class="flex items-center justify-center">
    <div class="max-w-105 space-y-2">
      <PocketIncidentsButtons>
        <template #default="{ incidentId, title }">
          <slot
            v-bind="{ incidentId, title }"
            name="pocketIncidentButton"
          />
        </template>
      </PocketIncidentsButtons>
      <div class="flex gap-x-2">
        <slot name="betButtons" />
      </div>
    </div>
  </Box>
</template>
